import React from 'react';
import BadgeSelector from '../components/BadgeSelector';

function getBadge({ badges, manufacturer }) {
    return <>
        {badges.length > 0 && badges?.map((badge, i) => <BadgeSelector
            key={i}
            type={badge.type} color={getColor(badge, manufacturer)} text={badge.text} discountValue={badge.discountValue}
            matchedProdQtyMultiplier={badge.matchedProdQtyMultiplier || 0}
        />)}
    </>

}

function getColor(badges, manufacturer) {
    return manufacturer && manufacturer.toLowerCase() === 'michelin' ? 'michelin' : badges.color;
}

export { getBadge };
